/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignDeckDTO
 */
export interface AssignDeckDTO {
    /**
     * 
     * @type {string}
     * @memberof AssignDeckDTO
     */
    deckId: string;
    /**
     * 
     * @type {string}
     * @memberof AssignDeckDTO
     */
    userId: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssignDeckDTO
     */
    sendEmail?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssignDeckDTO
     */
    addUserToEditors?: boolean;
}

/**
 * Check if a given object implements the AssignDeckDTO interface.
 */
export function instanceOfAssignDeckDTO(value: object): value is AssignDeckDTO {
    if (!('deckId' in value) || value['deckId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function AssignDeckDTOFromJSON(json: any): AssignDeckDTO {
    return AssignDeckDTOFromJSONTyped(json, false);
}

export function AssignDeckDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignDeckDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'deckId': json['deckId'],
        'userId': json['userId'],
        'sendEmail': json['sendEmail'] == null ? undefined : json['sendEmail'],
        'addUserToEditors': json['addUserToEditors'] == null ? undefined : json['addUserToEditors'],
    };
}

export function AssignDeckDTOToJSON(json: any): AssignDeckDTO {
    return AssignDeckDTOToJSONTyped(json, false);
}

export function AssignDeckDTOToJSONTyped(value?: AssignDeckDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deckId': value['deckId'],
        'userId': value['userId'],
        'sendEmail': value['sendEmail'],
        'addUserToEditors': value['addUserToEditors'],
    };
}

